import React from "react";
import { Link } from "react-router-dom";
import ContactForm from "@/components/ContactForm";
import SEO from "@/components/SEO";
import { Search, MapPinned, KeyRound, Calculator, ShieldCheck, ArrowRight } from "lucide-react";

export default function ComprarPage() {
  const steps = [
    { icon: Search, title: "1. Reunião e critérios", desc: "Ouço o que precisa: zona, orçamento, prazos, essenciais e desejáveis." },
    { icon: Calculator, title: "2. Pré-aprovação de crédito", desc: "Ligo-o a intermediários de crédito parceiros que trabalham para si." },
    { icon: MapPinned, title: "3. Visitas selecionadas", desc: "Só apresento imóveis que fazem sentido, poupando tempo e desilusões." },
    { icon: ShieldCheck, title: "4. Verificação legal", desc: "Análise documental, verificação de licenças, ónus e condição do imóvel." },
    { icon: KeyRound, title: "5. Negociação e escritura", desc: "Negoceio o melhor preço e condições, e acompanho até às chaves." },
  ];

  return (
    <div data-testid="page-comprar">
      <SEO
        title="Comprar casa no Porto — Consultora Zélia Silva"
        description="Encontre casa no Porto, Gondomar, Maia, Ermesinde e Valongo com uma consultora local. Reunião, visitas selecionadas, negociação e escritura, tudo com a Zélia Silva."
        canonical="https://casanoporto.com/comprar-casa-no-porto"
      />
      <section className="container-cnp pt-14 lg:pt-20 pb-12">
        <div className="max-w-3xl">
          <span className="tag-chip">Para compradores · Porto e Grande Porto</span>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-stone-900 leading-[1.05]">
            Comprar casa no Porto,<br/><span className="italic text-[#103C4A]">com tempo e critério.</span>
          </h1>
          <p className="mt-6 text-lg text-stone-600 leading-relaxed">
            Trabalho sobretudo com clientes que valorizam ser bem aconselhados. Não corro atrás de comissões:
            corro atrás da casa certa, para si.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/imoveis" data-testid="comprar-cta-imoveis" className="btn-primary">Ver imóveis à venda <ArrowRight className="h-4 w-4" /></Link>
            <Link to="/contacto" data-testid="comprar-cta-briefing" className="btn-secondary">Marcar reunião</Link>
          </div>
        </div>
      </section>

      <section className="bg-white border-y border-stone-200/70">
        <div className="container-cnp py-16 lg:py-20">
          <span className="tag-chip">Como trabalho</span>
          <h2 className="mt-4 font-display text-3xl md:text-4xl text-stone-900">Um método pensado para compradores exigentes.</h2>
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {steps.map((s, i) => (
              <div key={i} data-testid={`comprar-step-${i}`} className="card-soft p-7">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#103C4A]/10 text-[#103C4A]"><s.icon className="h-5 w-5" /></div>
                <h3 className="mt-4 text-lg text-stone-900">{s.title}</h3>
                <p className="mt-2 text-sm text-stone-600">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-cnp py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="tag-chip">Vamos começar</span>
            <h2 className="mt-4 font-display text-3xl md:text-4xl text-stone-900">Diga-me o que procura.</h2>
            <p className="mt-4 text-stone-600">Envio, no próprio dia útil, uma primeira seleção de imóveis alinhada com o seu perfil.</p>
          </div>
          <div className="lg:col-span-7 card-soft p-8">
            <ContactForm leadType="comprador" testidPrefix="comprar-contact" />
          </div>
        </div>
      </section>
    </div>
  );
}
